import styled from 'styled-components';
// styles
import * as animations from 'lib/styles/animations';
import { palette } from 'cds/styles';

/**
 * 클래스 사이드바 스켈레톤
 * @param {object}} props
 */
const ClassSideInfoSkeleton = () => {
  return (
    <div>
      <InfoLoading />
      <StarLoading />
      <PriceLoading />
      <BodyLoading />
    </div>
  );
};

const InfoLoading = styled.div`
  margin-bottom: 16px;
  width: 80%;
  height: 48px;
  border-radius: 8px;
  background-color: ${palette.grey030};
  animation: 2s ${animations.blink} ease infinite;
`;

const StarLoading = styled.div`
  margin-bottom: 24px;
  width: 32%;
  height: 38px;
  border-radius: 8px;
  background-color: ${palette.grey030};
  animation: 2s ${animations.blink} ease infinite;
`;

const PriceLoading = styled.div`
  margin-bottom: 24px;
  width: 42%;
  height: 59px;
  border-radius: 8px;
  background-color: ${palette.grey030};
  animation: 2s ${animations.blink} ease infinite;
`;

const BodyLoading = styled.div`
  height: 311px;
  border-radius: 8px;
  background-color: ${palette.grey030};
  animation: 2s ${animations.blink} ease infinite;
`;

export default ClassSideInfoSkeleton;
